import "./App.css";
import { ThemeProvider } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import HomePage from "./HomePage/HomePage";
import NewsletterPage from "./NewsletterPage/NewsletterPage";
import Redirect from "./Redirect/Redirect";
import CgaPage from "./CgaPage/CgaPage";
import MentionsLegalesPage from "./MentionsLegalesPage/MentionsLegalesPage";

import { theme } from "./utils/MUIStylePresets";
import ReactGA from "react-ga4";
import Hotjar from "@hotjar/browser";
import BlogPage from "./BlogPage/BlogPage";

ReactGA.initialize("G-PF0D62K19M");

const siteId = 3745209;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Routes>
          {/*<Route path="/blog" element={<BlogPage />} />*/}
        <Route path="/" element={<HomePage />} />
        <Route path="/newsletter" element={<NewsletterPage />} />
        <Route path="/cg" element={<CgaPage />} />
        <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
        <Route path="/redirect" element={<Redirect />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
